/* eslint-disable jsdoc/require-jsdoc */
import { useHistory } from 'react-router';

import TeamAvatar from 'components/base/TeamAvatar';
import { selectTeamId } from 'state/actions';
import { useDispatch, useSelector } from 'react-redux';
import { StyledTeamNameCell } from './Cells.style';
import { handleTeamChange } from 'connected-components/TopBar/TopBar.service';
import { isTeamLicenseSelector } from 'state/selectors/license';
import TeamGitScopeBanner from 'components/TeamGitScopeBanner';

const TeamNameCell = ({ team }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isTeamLicense = useSelector(isTeamLicenseSelector);

  return (
    <>
      <StyledTeamNameCell
        className='name'
        cursor='pointer'
        onClick={() =>
          handleTeamChange({
            team,
            selectTeamId: id => dispatch(selectTeamId(id)),
            history,
            isTeamLicense
          })
        }
      >
        <TeamAvatar team={team} />
        <div>{team.name}</div>
      </StyledTeamNameCell>
      <TeamGitScopeBanner team={team} />
    </>
  );
};
export default TeamNameCell;
